import React from "react";
import { TICKET_TASK_FILTERS } from "../../constants/TicketTaskFilter";

// function
const HistoryBox = (props) => {

  const STATUS_MAP = {
    O: "Open",
    I: "In Progress",
    S: "Support",
    E: "Email",
    P: "Phone Call",
    Q: "Pending On Client",
    R: "Resolved",
    K: "Reopened",
    "Practice EHR": "PracticeEHR",
    "Practice EHR PM": "PracticeEHR PM",
    "Practice EHR EPM": "PracticeEHR EPM",
  }

  const setOldNewValue = (value, type) => {
    if (type === "CATEGORY" || type === "TEAM") {
      value = toPascalCase(value);
    } else if (type === "PRODUCT TYPE") {
      value = filterProductType(value)
    } else {
      if (value === "Invalid date" || value === "01/01/0001") return "";
      return STATUS_MAP[value] || value;
    }
    return value;
  };

  const filterProductType = (value) => {
    const type = TICKET_TASK_FILTERS.PRODUCTS.find(item => item.value === value)
    return type !== '' ? type?.label : type;
  }


  const toPascalCase = (input) => {
    if (!input) return '';
    return input
      .toLowerCase()
      .replace(/[_\s]+/g, ' ')                      // Replace underscores with spaces
      .split(' ')                                   // Split into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize
      .join('');
  }


  function MakeHistoryType(words) {
    const separateWord = words.toLowerCase().split(" ");
    for (let i = 0; i < separateWord.length; i++) {
      separateWord[i] =
        separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
    }
    if (separateWord[0] === "Tickledate") {
      return "Tickle Date";
    }
    return separateWord.join(" ");

  }

  return (
    <div>
      <div className="tab-content">
        <div className="tab-pane active">
          <div className="row">
            <div className="col-md-12 col-sm-12 mb-2">
              <div className="commentsBox">
                <div className="commentHeader">
                  <span>
                    <a href="javascript:;">
                      {props.item.historyData.ENTERED_BY
                        ? `${props.item.historyData.ENTERED_BY.toLowerCase()} `
                        : ""}
                    </a>
                    made changes on -
                    <a href="javascript:;">
                      {` ${props.item.historyData.ENTERED_DATE} `}
                    </a>
                  </span>
                </div>
                <div className="commentBody">
                  <div style={{ lineHeight: "1.5" }} className="commentHeader">
                    <span>
                      <a href="javascript:;">
                        {MakeHistoryType(props.item.historyData.TYPE, props.item.historyData.TYPE)}
                      </a>
                      &nbsp; changed from -
                      <a href="javascript:;">
                        <span>
                          &nbsp;{" "}
                          {setOldNewValue(props.item.historyData.OLD_VALUE, props.item.historyData.TYPE)}{" "}
                          &nbsp;
                        </span>
                      </a>
                      to -
                      <a href="javascript:;">
                        <span>
                          {" "}
                          &nbsp;{" "}
                          {setOldNewValue(props.item.historyData.NEW_VALUE, props.item.historyData.TYPE)}
                        </span>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryBox;
